import {jwtDecode} from "jwt-decode";
import {isDevAuthBypassEnabled} from "./devAuthBypass";

export const storeTokens = (accessToken: string, refreshToken: string) => {
  localStorage.setItem('access_token', accessToken);
  localStorage.setItem('refresh_token', refreshToken);

  // Parse the JWT to extract the expiry time and store it
  const expiryTime = getTokenExpiryTime(accessToken);
  if (expiryTime) {
    localStorage.setItem('tokenExpiryTime', expiryTime.toString());
  }
};

export const getStoredToken = (): string => localStorage.getItem('access_token') || '';

export const getStoredRefreshToken = (): string => localStorage.getItem('refresh_token') || '';

/** True if a different refresh token has been stored since `usedRefreshToken` was read. */
export const tokensRotatedSince = (usedRefreshToken: string): boolean => {
  const current = getStoredRefreshToken();
  return Boolean(current) && current !== usedRefreshToken;
};

// Check if the user is logged in
export const userIsLoggedIn = (): boolean => {
  if (isDevAuthBypassEnabled()) {
    return true;
  }
  const token = getStoredRefreshToken();
  if (!token) {
    return false;
  }

  const expiryTime = getTokenExpiryTime(token);

  // User is logged in if token exists and is not expired
  return !!token && !!expiryTime && expiryTime > Date.now();
};

// Clear the session from localStorage: tokens plus the cached user, so the next sign-in in this
// browser doesn't start out as the previous user. Per-user preferences (keyed by user id) are kept.
export const clearTokens = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('tokenExpiryTime');
  localStorage.removeItem('user');
};

// Decode a JWT and extract the expiration time
export const getTokenExpiryTime = (token: string): number | null => {
  try {
    const decoded: { exp: number } = jwtDecode(token); // Ensure proper typing
    return decoded.exp * 1000; // Convert seconds to milliseconds
  } catch (error) {
    console.error('Failed to decode token:', error, token);
    return null;
  }
};